import {Component, Input, OnInit, inject} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TYPE} from "../../types/types";
import {VideoSrcDirective} from "../../directives/video-src.directive";
import {DocumentService} from "../../services/document.service";

@Component({
    selector: 'app-image-preview',
    imports: [
        NgOptimizedImage,
        VideoSrcDirective
    ],
    templateUrl: './image-preview.component.html',
    styleUrl: './image-preview.component.scss'
})
export class ImagePreviewComponent implements OnInit {
  private documentService: DocumentService = inject(DocumentService);

  @Input() public images: TYPE.Document[] = [];
  @Input() public videos: TYPE.Document[] = [];
  @Input() public hideReactions: boolean = true;

  public isFirstTall: boolean = false;
  public isPortrait: boolean = false;
  public isLargeEnough: boolean = false;
  public media: TYPE.Document[] = [];
  public autoplay: boolean = false;

  public ngOnInit(): void {
    this.prepare();
  }

  public showGallery(document: TYPE.Document): void {
    this.documentService.showGallery(this.media, document, this.hideReactions);
  }

  private prepare(): void {
    this.media = this.documentService.mergeDocuments(this.videos, this.images);
    if (this.media && this.media[0]) {
      const media = this.media[0];
      const height = Number(media.height);
      const width = Number(media.width);
      this.isPortrait = height > width;
      this.isLargeEnough = height > 500;
      //this.isFirstTall = isPortrait && isLargeEnough;
      this.isFirstTall = !!(this.media[0].width && this.media[0].height && Number(this.media[0].height) > Number(this.media[0].width));
      this.autoplay = this.media[0].type === 'video' && (this.media[0].size! / 1024 / 1024) < 40;
    }
  }
}
